import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import Cookies from "js-cookie";
import { logout, setCredentials } from "../../redux/slices/authSlice";
import {
  editProfile,
  getProfile,
  sendOtp,
  VERIFYOtp,
} from "../../service/operations/api_methods";
import { Smartphone } from "lucide-react";

const PageStyles = () => (
  <style>{`
    .login-shell {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 24px;
      width: 100%;
      height: 100vh;
      box-sizing: border-box;
      padding: 0 2vw;
      background: linear-gradient(75deg, #dbe4ebff 0%, #1f6aa0 100%);
    }
    /* both cards: same size */
    .login-card {
      width: 46%;
      height: 88vh;
      box-sizing: border-box;
      border-radius: 10px;
      border: 2px solid #ccc;
      box-shadow: 0 4px 8px rgba(94, 36, 36, 0.2);
      overflow: hidden;
    }
    @media (max-width: 900px) {
      .bus-card { display: none !important; }
      .login-card { width: 92%; }
    }

    /* ---------- bus scene animation ---------- */
    @keyframes cloud-drift { from { transform: translateX(-30%); } to { transform: translateX(520%); } }
    @keyframes road-move   { from { background-position: 0 0; } to { background-position: -120px 0; } }
    @keyframes hills-move  { from { transform: translateX(0); } to { transform: translateX(-50%); } }
    @keyframes bus-bob     { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-3px); } }
    @keyframes wheel-spin  { to { transform: rotate(360deg); } }
    @keyframes pin-float   { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-8px); } }

    .bus-card .cloud {
      position: absolute; left: 0; background: #fff; border-radius: 50px; opacity: .9;
      animation: cloud-drift linear infinite;
    }
    .bus-card .cloud::before, .bus-card .cloud::after {
      content: ""; position: absolute; background: #fff; border-radius: 50%;
    }
    .bus-card .cloud::before { width: 45%; height: 160%; top: -70%; left: 14%; }
    .bus-card .cloud::after  { width: 32%; height: 130%; top: -45%; right: 14%; }
    .bus-card .hills  { animation: hills-move 24s linear infinite; }
    .bus-card .road   {
      background-color: #2b3a4a;
      background-image: linear-gradient(90deg, #fff 0 60px, transparent 60px 120px);
      background-size: 120px 6px; background-repeat: repeat-x; background-position: 0 50%;
      animation: road-move 0.8s linear infinite;
    }
    .bus-card .bus    { animation: bus-bob 0.9s ease-in-out infinite; }
    .bus-card .wheel  { transform-box: fill-box; transform-origin: center; animation: wheel-spin 0.7s linear infinite; }
    .bus-card .pin    { animation: pin-float 3s ease-in-out infinite; }

    @media (prefers-reduced-motion: reduce) {
      .bus-card * { animation: none !important; }
    }
  `}</style>
);

const BusScene = () => (
  <div
    className="login-card bus-card"
    style={{ position: "relative", background: "#0d3b5c" }}
  >
    {/* background video */}
    <video
      src="/Assets/bus-login-vido.mp4"
      autoPlay
      muted
      loop
      playsInline
      style={{
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover",
      }}
    />

    {/* soft dark-blue fade at the bottom so the text is readable */}
    <div
      style={{
        position: "absolute",
        inset: 0,
        background:
          "linear-gradient(180deg, rgba(13,59,92,0) 45%, rgba(13,59,92,0.75) 100%)",
      }}
    />

    {/* headline */}
    <div
      style={{
        position: "absolute",
        bottom: "7%",
        left: 0,
        right: 0,
        textAlign: "center",
        padding: "0 28px",
        zIndex: 5,
      }}
    >
      <p
        style={{ fontSize: "30px", fontWeight: 700, color: "#fff", margin: 0 }}
      >
        Book your next bus journey
      </p>
      <p style={{ fontSize: "16px", color: "#dff3ff", marginTop: "10px" }}>
        Choose your seat, pick your route, travel with ease.
      </p>
    </div>
  </div>
);

const Login = () => {
  const token =
    useSelector((state) => state.auth.token) || Cookies.get("roam-token"); // for registering user
  const [otpMode, setOtpMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [number, setNumber] = useState("");
  const [register, setRegister] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const inputRefs = useRef([]);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [balance, setBalance] = useState("");

  const handleChange = (e, index) => {
    const value = e.target.value;

    if (!/^[0-9]?$/.test(value)) return; // allow only digits

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Move to next input if a value is entered
    if (value && index < otp.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    // Move back when Backspace pressed and current field is empty
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const sendOptHandler = async () => {
    if (!/^\d{10}$/.test(String(number))) {
      toast.error("Must be a 10-digit number");
      return;
    }

    try {
      setLoading(true);
      const response = await sendOtp(number);
      console.log("otp", response);
      if (response.status === 200) {
        setOtpMode(true);
        alert("Otp  has been sent ");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const verifyOptHandler = async () => {
    try {
      setLoading(true);
      const response = await VERIFYOtp({ number: number, otp: otp.join("") });
      console.log("otp", response);
      if (response.status === 200) {
        dispatch(
          setCredentials({
            token: response.data.token,
            user: response.data.user,
          }),
        );

        if (response.data.isNewUser) {
          toast.success("New user created - fill your details");
          // navigate("/myprofile")
          setRegister(true);
          return;
        }
        toast.success("Logged in Successfully!");
        navigate("/");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleGetProfile = async () => {
    try {
      const response = await getProfile(token);
      console.log("profile", response);
      if (response.status === 200) {
        setName(response.data.user.name);
        setEmail(response.data.user.email);
        setPhone(response.data.user.phone);
        setBalance(response.data.user.walletBalance);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleEditProfile = async () => {
    try {
      let data = {
        name: name,
        email: email,
        phone: phone,
      };

      const response = await editProfile({ data, token });
      console.log("edited", response);
      if (response.status === 200) {
        navigate("/");
        toast.success("User data created");
      }
    } catch (error) {
      console.log(error);
      if (error.status === 400) {
        toast.error("Email already exists");
        return;
      }
      toast.error("Failed to add data");
    }
  };

  useEffect(() => {
    if (register) {
      handleGetProfile();
    }
  }, [register]);

  return (
    <div className="login-shell">
      <PageStyles />

      {/* NEW: left visual card */}
      <BusScene />

      {/* RIGHT: your original white form card.
           Only the outer box changed: className="login-card" gives it the same size as the left card
           (46% width, 88vh height) and justifyContent: "center" keeps the form in the middle. */}
      <div
        className="login-card"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "start",
          padding: "10px",
          backgroundColor: "rgba(255, 255, 255, 0.42)",
          backdropFilter: "blur(30px)",
          WebkitBackdropFilter: "blur(30px)",
          overflowY: "auto",
          gap: "30px",
          border: "1px solid rgba(255, 255, 255, 0.35)",
        }}
      >
        <h1 style={{ color: "#686767", fontStyle: "italic" }}>
          {!register ? "Login to your Account" : "Register your account"}
        </h1>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "30px",
            borderRadius: "20px",
            backgroundColor: "#ddf2fc",
          }}
        >
          {!register && (
            <p style={{ fontSize: "20px", fontWeight: "500", padding: "20px" }}>
              Enter Your {otpMode ? "Otp" : "Number"}
            </p>
          )}

          {!register && !otpMode ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "20px",
              }}
            >
           <div
  style={{
    position: "relative",
    display: "flex",
    alignItems: "center",
  }}
>
  <Smartphone
    size={20}
    color="#888"
    strokeWidth={1.8}
    style={{
      position: "absolute",
      left: "12px",
      pointerEvents: "none",
    }}
  />

  <input
    placeholder="+91 1234567890"
    value={number}
    type="tel"
    onChange={(e) => setNumber(e.target.value)}
    style={{
      fontSize: "16px",
      padding: "10px 12px 10px 42px",
      borderRadius: "8px",
      outline: "none",
      border: "0.3px solid gray",
      boxSizing: "border-box",
    }}
  />
</div>
              {loading ? (
                <p
                  style={{
                    padding: "10px",
                    borderRadius: "8px",
                    backgroundColor: "rgb(33, 166, 255)",
                    fontWeight: "700",
                    color: "white",
                    cursor: "not-allowed",
                  }}
                >
                  ...
                </p>
              ) : (
                <p
                  style={{
                    padding: "10px",
                    borderRadius: "8px",
                    backgroundColor: "rgb(18, 145, 218)",
                    fontWeight: "700",
                    color: "white",
                    cursor: "pointer",
                    width: "100%",
                    textAlign: "center",
                  }}
                  onClick={sendOptHandler}
                >
                  Submit
                </p>
              )}
            </div>
          ) : !register && otpMode ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "20px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                {otp.map((value, index) => (
                  <input
                    style={{
                      fontSize: "20px",
                      padding: "6px",
                      borderRadius: "8px",
                      width: "40px",
                      textAlign: "center",
                      outline: "none",
                      border: "0.3px solid gray",
                    }}
                    ref={(el) => (inputRefs.current[index] = el)}
                    type="text"
                    value={value}
                    onChange={(e) => handleChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                  />
                ))}
              </div>

              {loading ? (
                <p
                  style={{
                    padding: "10px",
                    borderRadius: "8px",
                    backgroundColor: "#2137ffff",
                    fontWeight: "700",
                    color: "white",
                    cursor: "not-allowed",
                  }}
                >
                  ...
                </p>
              ) : (
                <p
                  style={{
                    padding: "10px",
                    borderRadius: "8px",
                    backgroundColor: "#2137ffff",
                    fontWeight: "700",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={verifyOptHandler}
                >
                  Submit
                </p>
              )}
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "20px",
              }}
            >
              <p
                style={{ fontSize: "25px", fontWeight: "600", padding: "20px" }}
              >
                Fill your details
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                  flexDirection: "column",
                }}
              >
                <label
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  Name:{" "}
                  <input
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    style={{
                      padding: "6px",
                      borderRadius: "5px",
                      border: "0.3px solid grey",
                      outline: "none",
                    }}
                  />
                </label>
                <label
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  {" "}
                  Email:
                  <input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    style={{
                      padding: "6px",
                      borderRadius: "5px",
                      border: "0.3px solid grey",
                      outline: "none",
                    }}
                  />
                </label>
                <label
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  Phone:
                  <input
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    style={{
                      padding: "6px",
                      borderRadius: "5px",
                      border: "0.3px solid grey",
                      outline: "none",
                    }}
                  />
                </label>
              </div>

              {loading ? (
                <p
                  style={{
                    padding: "10px",
                    borderRadius: "8px",
                    backgroundColor: "#2137ffff",
                    fontWeight: "700",
                    color: "white",
                    cursor: "not-allowed",
                  }}
                >
                  ...
                </p>
              ) : (
                <p
                  style={{
                    padding: "10px",
                    borderRadius: "8px",
                    backgroundColor: "#2137ffff",
                    fontWeight: "700",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={handleEditProfile}
                >
                  Submit
                </p>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
